
import { Component, Vue } from "vue-property-decorator"

@Component
export default class KraalSync extends Vue {
  async doSomething() {
    try {
      let gql = `mutation pubsubRequestDownForKraals($locationGuid: String!) {
        pubsubRequestDownForKraals(locationGuid: $locationGuid)
      }`

      let json = await this.$store.dispatch("graphQl", {
        gql,
        variables: { locationGuid: "TODO" },
      })

      console.log(JSON.stringify(json))
      return json
    } catch (err) {
      console.log("error: " + err)
      throw err
    }
  }
}
